import { Checkbox, FormControlLabel, Tooltip, Typography } from "@material-ui/core";
import React, { useEffect, useState } from "react";

import { Box } from "../../../../../../dtos/box";
import { BoxFeature } from "../../types";

import { useSaveIsBankBox } from "./useSaveIsBankBox";

interface Props {
    box: Box;
    onIsBankBoxChanged: () => void;
    feature: BoxFeature;
}

export function BankBoxCheckbox({
    box,
    onIsBankBoxChanged,
    feature,
}: Props) {
    const initialIsBankBox = Boolean(box.isBankBox);
    const [isBankBox, setIsBankBox] = useState(initialIsBankBox);
    const { saveIsBankBox, loading } = useSaveIsBankBox(box.id);

    useEffect(() => {
        if (initialIsBankBox === isBankBox) return;
        setIsBankBox(initialIsBankBox);
    }, [initialIsBankBox, isBankBox]);

    if (!feature.enabled && !isBankBox) {
        return null;
    }

    return (
        <FormControlLabel
            control={
                <Checkbox
                    value={isBankBox}
                    color="primary"
                    onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                        saveIsBankBox(event.target.checked, onIsBankBoxChanged)
                    }
                    checked={isBankBox}
                    disabled={!feature.enabled || loading}
                />
            }
            label={
                <Tooltip title={feature.reason}>
                    <Typography>Bank Box</Typography>
                </Tooltip>
            }
        />
    );
}
